import { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import logoimg from '../assets/img/logo/logo.png';

function Navbar() {
  const [isNavCollapsed, setIsNavCollapsed] = useState(true);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  return (
    <nav className="navbar navbar-expand-lg bg-white shadow-sm  sticky-top custom-navbar">
      <div className="container">
        {/* Brand Logo / Title */}
        <Link to="/" className="navbar-brand d-flex align-items-center fw-bold text-uppercase brand-text" style={{ fontSize: 'clamp(15px, 4.5vw, 20px)' }}>
          <img src={logoimg} alt="Mahawar Sabha Logo" className="me-2" style={{ height: 'clamp(40px, 8vw, 50px)' }} />
          <div className="d-flex flex-column flex-sm-row align-items-start align-items-sm-baseline">
            <span className="lh-sm">Mahawar Sabha</span>
            <span className="text-muted ms-sm-1" style={{ fontSize: 'clamp(11px, 3vw, 14px)' }}>(Reg), Rewari</span>
          </div>
        </Link>

        {/* Mobile Toggle Button */}
        <button className="navbar-toggler border-0" type="button" onClick={() => setIsNavCollapsed(!isNavCollapsed)} aria-controls="navbarContent" aria-expanded={!isNavCollapsed} aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Navbar Links */}
        <div className={`collapse navbar-collapse ${!isNavCollapsed ? 'show' : ''}`} id="navbarContent">
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0 fw-medium align-items-lg-center">
            <li className="nav-item">
              <NavLink className="nav-link px-3" aria-current="page" to="/" end>Home</NavLink>
            </li>
            <li className="nav-item dropdown">
              <span className="nav-link px-3" id="aboutDropdown" role="button" onClick={() => setIsDropdownOpen(!isDropdownOpen)} aria-expanded={isDropdownOpen} style={{ cursor: 'pointer' }}>
                About <i className="bi bi-chevron-down ms-1" style={{ fontSize: '0.8rem' }}></i>
              </span>
              <ul className={`dropdown-menu border-0 shadow-sm custom-dropdown ${isDropdownOpen ? 'show' : ''}`} aria-labelledby="aboutDropdown">
                <li><Link className="dropdown-item py-2" to="/#about" onClick={() => setIsDropdownOpen(false)}>About Us</Link></li>
                <li><Link className="dropdown-item py-2" to="/#team" onClick={() => setIsDropdownOpen(false)}>Team</Link></li>
                <li><Link className="dropdown-item py-2" to="/#objectives" onClick={() => setIsDropdownOpen(false)}>President Message</Link></li>
                <li><Link className="dropdown-item py-2" to="/about" onClick={() => setIsDropdownOpen(false)}>History</Link></li>
              </ul>
            </li>
            <li className="nav-item"><NavLink className="nav-link px-3" to="/member-list">Member List</NavLink></li>
            <li className="nav-item"><NavLink className="nav-link px-3" to="/gallery">Gallery</NavLink></li>
            <li className="nav-item"><NavLink className="nav-link px-3" to="/media">Media</NavLink></li>
            <li className="nav-item"><Link className="nav-link px-3" to="/activity">Activity</Link></li>
            <li className="nav-item"><NavLink className="nav-link px-3" to="/contact">Contact</NavLink></li>

            {/* Optional Call to Action Button 
            <li className="nav-item ms-lg-3 mt-3 mt-lg-0">
              <a href="#join" className="btn btn-danger rounded-pill px-4 py-2 nav-btn">Join Us</a>
            </li>*/}
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
